import { MenusSection } from "@/components/MenusSection";
import { QuoteButton } from "@/components/QuoteButton";
import { Seo } from "@/lib/seo";
import { useSiteImage } from "@/context/ContentContext";

export default function Menus() {
  const img = useSiteImage();
  return (
    <div data-testid="menus-page">
      <Seo
        title="Nos menus & cartes — Traiteur Afro Regal (africain, créole, français)"
        description="Découvrez les cartes Afro Regal : cuisine africaine (Safari Grill), saveurs des îles, apéritifs, cocktails et petits fours. Menus personnalisables sur devis — nous réalisons aussi votre menu sur mesure."
      />
      <section className="pb-10 pt-32 lg:pt-40" data-testid="menus-hero">
        <div className="mx-auto max-w-5xl px-5 text-center lg:px-8">
          <div className="mx-auto mb-8 h-24 w-24 overflow-hidden rounded-full border border-[#C9A84C]/50 p-1">
            <img src={img("menus_hero")} alt="" aria-hidden="true" className="h-full w-full rounded-full object-cover" />
          </div>
          <p className="text-sm uppercase tracking-[0.35em] text-[#9A7B2C]">Nos menus & cartes</p>
          <h1 className="mt-5 font-serif text-5xl font-500 text-[#2C2C2C] sm:text-6xl lg:text-7xl">Découvrez notre carte</h1>
          <div className="mx-auto mt-8 flex max-w-xs items-center gap-4" aria-hidden="true">
            <span className="h-px flex-1 bg-[#C9A84C]/60" /><span className="h-1.5 w-1.5 rotate-45 bg-[#C9A84C]" /><span className="h-px flex-1 bg-[#C9A84C]/60" />
          </div>
          <p className="mx-auto mt-8 max-w-2xl font-serif text-xl italic leading-relaxed text-[#2C2C2C]/75 lg:text-2xl">
            Des cartes africaines, créoles et françaises, pensées pour les mariages, les événements privés et professionnels. Consultez chaque carte en détail — et si vous avez votre propre idée, nous la réalisons pour vous.
          </p>
          <div className="mt-9 flex justify-center">
            <QuoteButton testId="menus-hero-quote">Demander un devis</QuoteButton>
          </div>
        </div>
      </section>

      <MenusSection showAllButton={false} />
    </div>
  );
}
